import {
  isCustomizedType,
  isDefinedString,
  isPositiveNumber,
  reduce
} from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat101CStore from "../../stores/khattabat-stores/101c-stores";

export const apiCallCreateOneOTwo = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data: {};
  status: string;
  code: Ti18nKeys;
}> => {
  const { oneOOneCId, userUUID, insertUserIdField } =
    getKhattabat101CStore(userID);
  const alKhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const matchUserId = insertUserIdField.get();

  if (!isPositiveNumber(matchUserId) || !isDefinedString(oneOOneCId.get())) {
    return {
      data: {},
      status: "ERROR",
      code: "ERROR"
    };
  }
  const { status, data, et3Error } = await post<{}>(`khattabat/createOneOTwo`, {
    alKhattabaUUID,
    userUUID: userUUID.get(),
    userID,
    matchUserId
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {},
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {},
      status: "ERROR",
      code: "ERROR"
    };
  }
};
